import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, HeartIcon } from 'lucide-react';
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.1
    }
  }
};
const childVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function ResultsSection() {
  return <section className="w-full px-5 py-20 md:py-28" style={{
    backgroundColor: 'var(--color-white)'
  }} data-id="element-211">
      <motion.div className="max-w-[720px] mx-auto" initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={sectionVariants} data-id="element-212">
        <motion.h2 variants={childVariants} className="text-3xl md:text-4xl mb-6" style={{
        color: 'var(--color-slate)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-213">
          ¿Qué cambia en 21 días?
        </motion.h2>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-10" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-214">
          No te voy a vender fantasías. Lo que cambia primero es:
        </motion.p>

        <motion.div variants={childVariants} className="space-y-5 mb-12" data-id="element-215">
          <div className="flex items-start gap-4" data-id="element-216">
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
            backgroundColor: 'var(--color-sage)',
            opacity: 0.2
          }} data-id="element-217">
              <CheckIcon className="w-4 h-4" style={{
              color: 'var(--color-sage)'
            }} data-id="element-218" />
            </div>
            <div data-id="element-219">
              <p className="text-lg md:text-xl font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-220">
                "Ya lo hice"
              </p>
              <p className="text-base md:text-lg" style={{
              color: 'var(--color-slate)',
              opacity: 0.7
            }} data-id="element-221">
                Cumplimiento — la sensación de haber hecho algo por ti hoy.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-222">
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
            backgroundColor: 'var(--color-sage)',
            opacity: 0.2
          }} data-id="element-223">
              <CheckIcon className="w-4 h-4" style={{
              color: 'var(--color-sage)'
            }} data-id="element-224" />
            </div>
            <div data-id="element-225">
              <p className="text-lg md:text-xl font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-226">
                Energía
              </p>
              <p className="text-base md:text-lg" style={{
              color: 'var(--color-slate)',
              opacity: 0.7
            }} data-id="element-227">
                Porque tu cuerpo se activa con movimiento constante.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-228">
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
            backgroundColor: 'var(--color-sage)',
            opacity: 0.2
          }} data-id="element-229">
              <CheckIcon className="w-4 h-4" style={{
              color: 'var(--color-sage)'
            }} data-id="element-230" />
            </div>
            <div data-id="element-231">
              <p className="text-lg md:text-xl font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-232">
                Postura
              </p>
              <p className="text-base md:text-lg" style={{
              color: 'var(--color-slate)',
              opacity: 0.7
            }} data-id="element-233">
                Porque trabajas fuerza básica que sostiene tu cuerpo.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-234">
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
            backgroundColor: 'var(--color-sage)',
            opacity: 0.2
          }} data-id="element-235">
              <CheckIcon className="w-4 h-4" style={{
              color: 'var(--color-sage)'
            }} data-id="element-236" />
            </div>
            <div data-id="element-237">
              <p className="text-lg md:text-xl font-semibold" style={{
              color: 'var(--color-slate)'
            }} data-id="element-238">
                Firmeza
              </p>
              <p className="text-base md:text-lg" style={{
              color: 'var(--color-slate)',
              opacity: 0.7
            }} data-id="element-239">
                Porque repites estímulo — consistencia real, no perfección.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Separator */}
        <motion.div variants={childVariants} className="w-16 h-px mx-auto mb-10" style={{
        backgroundColor: 'var(--color-tan)'
      }} data-id="element-240" />

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-4" style={{
        color: 'var(--color-slate)',
        opacity: 0.85
      }} data-id="element-241">
          Y cuando eso aparece, pasa algo más grande:
        </motion.p>

        <motion.div variants={childVariants} className="flex items-start gap-4 rounded-2xl p-6 md:p-8" style={{
        backgroundColor: 'var(--color-cream)'
      }} data-id="element-242">
          <HeartIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
          color: 'var(--color-tan)'
        }} data-id="element-243" />
          <p className="text-xl md:text-2xl leading-relaxed" style={{
          color: 'var(--color-slate)',
          fontFamily: "'DM Serif Display', serif"
        }} data-id="element-244">
            Dejas de sentirte a merced del caos.
          </p>
        </motion.div>
      </motion.div>
    </section>;
}